import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import ToastPlugin from 'vue-toast-notification';
import { LoadingPlugin } from 'vue-loading-overlay';
import { installAuthFetch } from '@/services/authFetch';
import { getApiExceptionPayload, isApiException } from '@/services/apiErrorToast';
import 'vue-toast-notification/dist/theme-bootstrap.css';
import 'vue-loading-overlay/dist/css/index.css';
import '@/assets/css/app.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

installAuthFetch();

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(ToastPlugin);
app.use(LoadingPlugin);

app.config.errorHandler = (error, instance) => {
  if (!isApiException(error)) {
    throw error;
  }

  if (error?.__apiToastShown) {
    return;
  }

  if (error && typeof error === 'object') {
    error.__apiToastShown = true;
  }

  const toast = instance?.proxy?.$toast || app.config.globalProperties.$toast;
  if (toast) {
    const payload = getApiExceptionPayload(error);
    toast.open({
      message: payload.message || 'API request failed.',
      type: 'error',
      position: 'top-right'
    });
  }
};

app.mount('#app');
